/**
 * The "General message to vendor" that goes with every counter RFI sends (Lance, 28 Oct: the chat pop-up gets the same
 * message box as the Estimates tab). Pre-filled so the vendor always hears why the estimate changed; the admin may edit
 * it, and clearing it sends the counter with no message.
 */
export const DEFAULT_COUNTER_MESSAGE =
  'Please review the revised line items and let us know if you can accept the updated costs.';

/** What goes on the wire: the typed text trimmed, or null when the admin cleared the box. */
export function counterMessageForSend(text: string | null | undefined): string | null {
  const trimmed = (text ?? '').trim();
  return trimmed ? trimmed : null;
}
